module.exports = __webpack_public_path__ + "static/media/vn.91b580a0.svg";